import { CheckBox, Text } from "@ui-kitten/components";
import AutoRenewalDisclosureModal from "components/AutoRenewalDisclosureModal";
import { AgreementDetails } from "features/types";
import React, { useState } from "react";
import { Pressable, View } from "react-native";

interface AutoRenewalConsentSectionProps {
  agreements: AgreementDetails[] | undefined;
  consentGiven: boolean;
  onChange: (v: boolean) => void;
  // Renders the checkbox label light for use on dark backgrounds.
  onDark?: boolean;
}

const AutoRenewalConsentSection: React.FC<AutoRenewalConsentSectionProps> = ({
  agreements,
  consentGiven,
  onChange,
  onDark = false,
}) => {
  const [modalVisible, setModalVisible] = useState(false);

  if (!agreements || agreements.length === 0) return null;

  return (
    <View style={{ marginBottom: 16 }}>
      <AutoRenewalDisclosureModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        agreementBody={agreements[0].body ?? ""}
      />
      <CheckBox
        testID="auto-renewal-checkbox"
        checked={consentGiven}
        onChange={onChange}
        status={onDark ? "control" : "basic"}
      >
        {(evaProps) => (
          <Text {...evaProps} status={onDark ? "control" : "basic"}>
            I have read and agreed to the auto renewal terms of service
          </Text>
        )}
      </CheckBox>
      <Pressable onPress={() => setModalVisible(true)} style={{ marginTop: 8 }}>
        <Text status="info">View auto-renewal terms</Text>
      </Pressable>
    </View>
  );
};

export default AutoRenewalConsentSection;
